import React from 'react'
import {Form, Input} from 'antd'

const BInput = ({label, fieldName, rules, placeholder, Icon, disabled, type, password, style, white}) => (
  <div className='bInput'>
    {label && <label className='bInputLabel' htmlFor={fieldName}>{label}</label>}
    <div style={style} className={'bInputDiv' + (white ? ' white' : '')}>
      {Icon}
      <Form.Item name={fieldName} rules={rules ?? []}>
        <Input
          id={fieldName}
          type={type ?? password ? 'password' : 'text'}
          disabled={disabled}
          placeholder={placeholder ?? (placeholder !== false ? label : '')}
        />
      </Form.Item>
    </div>
  </div>
)

export default BInput
